export default __webpack_public_path__ + "static/media/resume.af8054b3.pdf";